import { useEffect, useMemo, useState } from "react";
import { useTextos } from "../context/useTextos";
import { useWorkshop } from "../context/useWorkshop";
import { veiculoService, clienteService } from "../services/cadastroService";

const EMPTY = { placa: "", marca: "", modelo: "", ano: "", km: "", clienteId: "" };

export default function VeiculosPage() {
  const { t } = useTextos();
  const { workshopId } = useWorkshop();
  const [reloadToken, setReloadToken] = useState(0);
  const [editando, setEditando] = useState(null);

  const [veiculos, setVeiculos] = useState([]);
  const [erro, setErro] = useState("");
  useEffect(() => {
    veiculoService.list(workshopId).then(setVeiculos);
  }, [workshopId, reloadToken]);
  const [clientes, setClientes] = useState([]);
  useEffect(() => {
    clienteService.list(workshopId).then(setClientes);
  }, [workshopId, reloadToken]);
  const clientesPorId = useMemo(
    () => Object.fromEntries(clientes.map((c) => [c.id, c])),
    [clientes]
  );

  async function salvar(e) {
    e.preventDefault();
    setErro("");
    try {
      await veiculoService.save(workshopId, editando);
      setEditando(null);
      setReloadToken((t) => t + 1);
    } catch (err) {
      setErro(err.message || t("checklist.veiculos_erro_salvar"));
    }
  }

  async function excluir(id) {
    if (window.confirm(t("checklist.veiculos_confirm_excluir"))) {
      try {
        await veiculoService.remove(workshopId, id);
        setReloadToken((v) => v + 1);
      } catch (err) {
        setErro(err.message || t("checklist.veiculos_erro_excluir"));
      }
    }
  }

  return (
    <div className="page">
      <header className="page__header">
        <h2>{t("checklist.veiculos_titulo")}</h2>
        <button className="btn btn--primary" onClick={() => setEditando({ ...EMPTY })}>
          {t("checklist.veiculos_novo")}
        </button>
      </header>

      {erro && (
        <div style={{
          background: "#fef2f2", border: "1px solid #fca5a5", color: "#b91c1c",
          borderRadius: 8, padding: "10px 14px", marginBottom: 12, fontSize: 13, fontWeight: 600,
        }}>
          {erro}
        </div>
      )}

      {editando && (
        <form className="form-section" onSubmit={salvar}>
          <div className="form-grid">
            <label>
              {t("checklist.veiculos_placa")}
              <input
                required
                value={editando.placa}
                onChange={(e) =>
                  setEditando({ ...editando, placa: e.target.value.toUpperCase() })
                }
              />
            </label>
            <label>
              {t("checklist.veiculos_marca")}
              <input
                value={editando.marca}
                onChange={(e) => setEditando({ ...editando, marca: e.target.value })}
              />
            </label>
            <label>
              {t("checklist.veiculos_modelo")}
              <input
                value={editando.modelo}
                onChange={(e) => setEditando({ ...editando, modelo: e.target.value })}
              />
            </label>
            <label>
              {t("checklist.veiculos_ano")}
              <input
                value={editando.ano}
                onChange={(e) => setEditando({ ...editando, ano: e.target.value })}
              />
            </label>
            <label>
              {t("checklist.veiculos_km_atual")}
              <input
                value={editando.km}
                onChange={(e) => setEditando({ ...editando, km: e.target.value })}
              />
            </label>
            <label>
              {t("checklist.veiculos_cliente")}
              <select
                value={editando.clienteId}
                onChange={(e) => setEditando({ ...editando, clienteId: e.target.value })}
              >
                <option value="">{t("checklist.veiculos_sem_cliente")}</option>
                {clientes.map((c) => (
                  <option key={c.id} value={c.id}>
                    {c.nome}
                  </option>
                ))}
              </select>
            </label>
          </div>
          <div className="checklist-form__footer">
            <button type="button" className="btn btn--ghost" onClick={() => setEditando(null)}>
              {t("common.cancelar")}
            </button>
            <button type="submit" className="btn btn--primary">
              {t("common.salvar")}
            </button>
          </div>
        </form>
      )}

      {veiculos.length === 0 ? (
        <p className="empty-state">{t("checklist.veiculos_nenhum")}</p>
      ) : (
        <div className="table-scroll">
          <table className="checklist-table">
          <thead>
            <tr>
              <th>{t("checklist.veiculos_placa")}</th>
              <th>{t("checklist.col_veiculo")}</th>
              <th>{t("checklist.veiculos_cliente")}</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {veiculos.map((v) => (
              <tr key={v.id}>
                <td>{v.placa}</td>
                <td>
                  {v.marca} {v.modelo} {v.ano ? `(${v.ano})` : ""}
                </td>
                <td>{clientesPorId[v.clienteId]?.nome || "—"}</td>
                <td>
                  <button className="btn btn--ghost btn--small" onClick={() => setEditando(v)}>
                    {t("common.editar")}
                  </button>
                  <button className="btn btn--ghost btn--small" onClick={() => excluir(v.id)}>
                    {t("common.excluir")}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        </div>
      )}
    </div>
  );
}
